import * as React from 'react';
import { Route, Routes, useParams } from "react-router-dom"
import { AppSection } from '../../components/AppSection';
import { MarkdownContent } from '../../components/MarkdownContent';
import { MainPadding } from '../../components/MainPadding';
import { Paper } from '@mui/material';
import { SafeUrlGenerator } from './components/SafeUrlGenerator';

function MarkdownPageRoute() {
  const params = useParams();
  const splat = params['*'] || '';
  const mPath = splat.replace(/(^\/|\/$)/g, '');
  const path = '/md/' + mPath + '.md';
  return (
    <MainPadding key={mPath}>
      <AppSection section={`tools/${mPath}`} />
      <Paper style={{ padding: 16 }}>
        <MarkdownContent path={path} />
      </Paper>
    </MainPadding>
  );
}

function SafeUrlGenRoute() {
  return (
    <MainPadding>
      <AppSection section={`tools/safe-url-gen`} />
      <Paper style={{ padding: 16 }}>
        <MarkdownContent path={'/md/safe-url-gen.md'} />
        <SafeUrlGenerator />
      </Paper>
    </MainPadding>
  );
}

function DocumentationRoute() {
  return (
    <MainPadding>
      <AppSection section={`tools/documentation`} />
      <Paper style={{ padding: 16 }}>
        <a href="https://bit.ly/webdrvn-hugo-documentation" target='_blank'>Click here for Hugo Documentation </a>
      </Paper>
    </MainPadding>
  );
}

export class Tools extends React.Component<any, any>{

  public render() {
    return (<React.Fragment>
      <Routes>
        <Route path="documentation" element={<DocumentationRoute />} />
        <Route path="safe-url-gen" element={<SafeUrlGenRoute />} />
        <Route path="*" element={<MarkdownPageRoute />} />
      </Routes>
    </React.Fragment>)
  }
}
